var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyMaimu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 45,
    viewBox: "0 0 94 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 84,
    height: 35,
    fill: "#F7FBFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 84,
    height: 5,
    fill: "#DEDEDE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 40,
    width: 84,
    height: 5,
    fill: "#DEDEDE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 5,
    height: 35,
    fill: "#DEDEDE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 5,
    width: 5,
    height: 35,
    fill: "#DEDEDE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 84,
    height: 17,
    fill: "#DEDEDE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 36,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 36,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 31,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 31,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 31,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 36,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 8,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 8,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 8,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 8,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 16,
    width: 4,
    height: 4,
    fill: "#DEDEDE"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 23,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 19,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 27,
    width: 4,
    height: 4,
    fill: "#F7FBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMaimu);
export default __webpack_public_path__ + "static/media/GreyMaimu.9549df404c2ee0de5310beb63706e874.svg";
export { ForwardRef as ReactComponent };